/**
 * Program: Router
 * Author: SDL
 * Description: router setting file
 */
/* eslint-disable */
import SDLUtil from '@/utils/SDLUtil';
// publish - ohy : 20220715
import MainPageHtml from '@/components/view/admin/main/MainPageHtml';
import LayoutMain from '@/components/view/markup/layout/LayoutMain';
import LayoutDefault from '@/components/view/markup/layout/LayoutDefault';

export default {
  name: 'markup',
  path: `${SDLUtil.WEB_CONTEXT_PATH}/markup`,
  component: MainPageHtml,
  children: [
    {
      name: 'worksheet',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/markup/worksheet`,
      component: () => import('@/components/view/markup/worksheet'),
    },
    {
      name: 'LayerSample',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/markup/LayerSample`,
      component: () => import('@/components/view/markup/layout/LayerSample'),
    },
    {
      name: 'UI_HOME_0001',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/markup/UI_HOME_0001`,
      component: () => import('@/components/view/markup/page/home/UI_HOME_0001'),
    },
    {
      path: `error1`,
      component: LayoutDefault,
      children: [
        {
          path: `${SDLUtil.WEB_CONTEXT_PATH}/markup/Error1`,
          component: () => import('@/components/view/markup/layout/Error1'),
        },
      ],
    },
    {
      path: `error2`,
      component: LayoutDefault,
      children: [
        {
          path: `${SDLUtil.WEB_CONTEXT_PATH}/markup/Error2`,
          component: () => import('@/components/view/markup/layout/Error2'),
        },
      ],
    },
    {
      path: `home`, // 경로 : /markup/pubDataLayout/pubDataList
      component: LayoutMain,
      children: [
        {
          path: `UI_HOME_0002`,
          component: () => import('@/components/view/markup/page/home/UI_HOME_0002'),
        },
        {
          path: `UI_HOME_0003`,
          component: () => import('@/components/view/markup/page/home/UI_HOME_0003'),
        },
        {
          path: `UI_HOME_0004`,
          component: () => import('@/components/view/markup/page/home/UI_HOME_0004'),
        },
      ],
    },
    {
      path: `layout`,
      component: LayoutDefault,
      children: [
        {
          path: `SubLayout`,
          component: () => import('@/components/view/markup/layout/TableNoData'),
        },
        {
          path: `TableNoData`,
          component: () => import('@/components/view/markup/layout/TableNoData'),
        },
      ],
    },
    {
      path: `voc`,
      component: LayoutDefault,
      children: [
        {
          path:`UI_VOC_0001`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0001'),
        },
        {
          path:`UI_VOC_0002`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0002'),
        },
        {
          path:`UI_VOC_0003`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0003'),
        },
        {
          path:`UI_VOC_0004`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0004'),
        },
        {
          path:`UI_VOC_0006`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0006'),
        },
        {
          path:`UI_VOC_0007`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0007'),
        },
        {
          path:`UI_VOC_0008`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0008'),
        },
        {
          path:`UI_VOC_0010`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0010'),
        },
        {
          path:`UI_VOC_0012`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0012'),
        },
        {
          path:`UI_VOC_0013`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0013'),
        },
        {
          path:`UI_VOC_0014`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0014'),
        },
        {
          path:`UI_VOC_0016`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0016'),
        },
        {
          path:`UI_VOC_0017`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0017'),
        },
        {
          path:`UI_VOC_0019`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0019'),
        },
        {
          path: `UI_VOC_0020`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0020'),
        },
        {
          path:`UI_VOC_0021`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0021'),
        },
        {
          path:`UI_VOC_0022`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0022'),
        },
        {
          path: `UI_VOC_0025`,
          component: () => import('@/components/view/markup/page/voc/UI_VOC_0025'),
        },
      ],
    },
    {
      path: `about`,
      component: LayoutDefault,
      children: [
        {
          path:`UI_ABOUT_0001`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0001'),
        },
        {
          path:`UI_ABOUT_0002`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0002'),
        },
        {
          path:`UI_ABOUT_0003`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0003'),
        },
        {
          path:`UI_ABOUT_0004`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0004'),
        },
        {
          path:`UI_ABOUT_0005`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0005'),
        },
        {
          path:`UI_ABOUT_0006`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0006'),
        },
        {
          path:`UI_ABOUT_0008`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0008'),
        },
        {
          path:`UI_ABOUT_0009`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0009'),
        },
        {
          path:`UI_ABOUT_0010`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0010'),
        },
        {
          path:`UI_ABOUT_0011`,
          component: () => import('@/components/view/markup/page/about/UI_ABOUT_0011'),
        },
      ],
    },
    {
      path: `admin`,
      component: LayoutDefault,
      children: [
        {
          path:`UI_ADMIN_0002`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0002'),
        },
        {
          path:`UI_ADMIN_0003`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0003'),
        },
        {
          path:`UI_ADMIN_0004`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0004'),
        },
        {
          path:`UI_ADMIN_0005`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0005'),
        },
        {
          path:`UI_ADMIN_0006`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0006'),
        },
        {
          path:`UI_ADMIN_0007`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0007'),
        },
        {
          path:`UI_ADMIN_0008`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0008'),
        },
        {
          path: `UI_ADMIN_0009`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0009'),
        },
        {
          path:`UI_ADMIN_0010`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0010'),
        },
        {
          path:`UI_ADMIN_0011`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0011'),
        },
        {
          path:`UI_ADMIN_0012`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0012'),
        },
        {
          path:`UI_ADMIN_0013`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0013'),
        },
        {
          path: `UI_ADMIN_0014`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0014'),
        },
        {
          path:`UI_ADMIN_0015`,
          component: () => import('@/components/view/markup/page/admin/UI_ADMIN_0015'),
        },
      ],
    },
    {
      name: 'swipe',
      path: `swipe`,
      component: () => import('@/components/view/sample/AwesomeSwiper'),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/markupRouter.js